import { Component } from '@angular/core';
import { OtpVerifyService } from '../../services/otp-verify.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-otp-verify',
  imports: [CommonModule, FormsModule],
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss']
})
export class OtpVerifyComponent {
  public otpCode:string = '';
  public secondCode:string = '';
  public otpVerifyError:string = '';
  public loadingRequest: boolean = false;
  
  constructor(
    private _otpService: OtpVerifyService) { }

  verifyOTP(){
    if(!this.otpCode || !this.secondCode){
      this.otpVerifyError = "Both fields are required.";
      return;
    };

    if(this.otpCode.length != 4 || this.secondCode.length != 4){
      this.otpVerifyError = "Both fields must be exactly 4 digits.";
      return;
    };

    this.loadingRequest = true;
    this._otpService.verify(this.otpCode, this.secondCode).subscribe({
      next: res => {
        if(res.code == 200){
          document.location.href = `${environment.baseUrl}/chat?conversationId=${res.conversationId}&organizationId=${res.organizationId}&joinCode=${res.joinCode}`;
        }
        else {
          this.otpVerifyError = res.message;
        }
        this.loadingRequest = false;
      },
      error: err => {
        console.error('Failed to verify OTP:', err);
        this.otpVerifyError = "Failed to verify OTP. Please try again.";
        this.loadingRequest = false;
      }
    });
  }
}